import React from 'react';
import './BulkUpload.css';
import Sidebar from '../../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../../assests/leftArrow.svg"
import { useNavigate } from "react-router-dom";
import validationsuccess from "../../../../assests/validationsuccess.svg"
import validationfailed from "../../../../assests/validationfailed.svg"
import csvicon from "../../../../assests/csvicon.png"

const BulkUpload = ({
  currentStep,
  uploadedFile,
  validationStatus,
  mappingData,
  validationResults,
  isValidating,
  isMapping,
  showAlreadyMapped,
  showValidationDialog,
  showMappingSuccessDialog,
  showMissingRecordsDialog,
  uploadProgress,
  headerError,
  onFileUpload,
  onDrop,
  onDragOver,
  onValidate,
  onRemoveEntry,
  onRemoveAllAlreadyMapped,
  onMap,
  onReset,
  onTryAgain,
  setCurrentStep,
  onValidationDialogOk,
  onMappingSuccessDialogOk,
  onMissingRecordsDialogOk,
  getUploadProgressPercentage,
  getUploadProgressText
}) => {
  const navigate = useNavigate();

  const getFileEntitiesCount = () => {
    if (validationResults) {
      return validationResults.totalEntries;
    }
    return mappingData.length;
  };

  const hasNoUnmappedEntries = !showAlreadyMapped && mappingData.length === 0;
  const isValidationFailed = validationStatus === 'error';

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div className="bu-main-container">
        <div className="bu-header-section">
          <button className="bu-back-button" onClick={() => navigate(-1)}>
            <img src={leftArrow} alt="Back" />
          </button>
          <h1 className="bu-header-title">Bulk Upload</h1>
        </div>

        <div className="bu-stepper">
          <div className={`bu-step ${currentStep >= 1 ? 'bu-step-active' : ''}`}>
            <div className="bu-step-number">1</div>
            <div className="bu-step-label">Upload File</div>
          </div>
          <div className="bu-step-connector"></div>
          <div className={`bu-step ${currentStep >= 2 ? 'bu-step-active' : ''}`}>
            <div className="bu-step-number">2</div>
            <div className="bu-step-label">Validation</div>
          </div>
          <div className="bu-step-connector"></div>
          <div className={`bu-step ${currentStep >= 3 ? 'bu-step-active' : ''}`}>
            <div className="bu-step-number">3</div>
            <div className="bu-step-label">Mapping</div>
          </div>
        </div>

        <div className="bu-content-wrapper">
          {/* Step 1: Upload File */}
          {currentStep === 1 && (
            <div className="bu-step-content">
              <div className="upload-section">
                <h2 className="bu-step-heading">Upload File</h2>
                <div className="bu-file-upload-area" onDrop={onDrop} onDragOver={onDragOver}>
                  <div className="upload-placeholder">
                    <p className="bu-upload-placeholder-text">Choose file or drag here</p>
                  </div>
                  <input
                    type="file"
                    id="bu-file-upload"
                    onChange={onFileUpload}
                    accept=".csv"
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="bu-file-upload" className="bu-file-upload-label">
                    Select File
                  </label>
                </div>
                
                {/* Header Error Message */}
                {headerError && (
                  <div className="bu-header-error-message">
                    {/* <div className="bu-error-icon">⚠️</div> */}
                    <div className="bu-error-content">
                      <strong>Invalid File Format</strong>
                      <p>{headerError}</p>
                      <small>Please ensure your CSV file has these columns: <code>uid, vmId</code></small>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Step 2: Validation */}
          {currentStep === 2 && (
            <div className="bu-step-content">
              <div className="validation-section">
                <h2 className="bu-step-heading">Validation</h2>

                {uploadedFile && (
                  <div className="bu-upload-status">
                    <div className="bu-status-message bu-status-message-success">
                      File Uploaded Successfully
                    </div>

                    <div className="bu-file-item">
                      <div className="file-checkbox">
                        <img className="bu-csv-icon" src={csvicon} alt="" />
                      </div>
                      <div className="bu-file-details">
                        <span className="bu-file-name">{uploadedFile.name}</span>
                        <div className="bu-progress-container">
                          <div className="bu-progress-bar">
                            <div
                              className="bu-progress-fill"
                              style={{ width: `${getUploadProgressPercentage()}%` }}
                            ></div>
                          </div>
                          <span className="bu-progress-text">{getUploadProgressText()}</span>
                        </div>
                      </div>
                    </div>

                    {validationStatus === 'ready' && (
                      <div className="bu-validate-action">
                        <button
                          className="bu-btn-validate"
                          onClick={onValidate}
                          disabled={isValidating}
                        >
                          {isValidating ? 'Validating...' : 'Validate'}
                        </button>
                      </div>
                    )}

                    {validationStatus === 'progress' && (
                      <div className="bu-validation-progress">
                        <div className="bu-progress-message">
                          Validation in Progress
                        </div>
                      </div>
                    )}

                    {validationStatus === 'success' && (
                      <div className="bu-validation-complete">
                        <div className="bu-status-message bu-status-message-success-emoji">
                          <span className="bu-emoji">😊</span>
                          File Uploaded Successfully
                        </div>
                        <div className="bu-validation-result">
                          Validation Successful
                        </div>
                        <button className="bu-btn-ok" onClick={() => setCurrentStep(3)}>
                          Ok
                        </button>
                      </div>
                    )}

                    {isValidationFailed && (
                      <div className="bu-try-again-section">
                        <button className="bu-btn-try-again" onClick={onTryAgain}>
                          Try Again
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Step 3: Mapping */}
          {currentStep === 3 && (
            <div className="bu-step-content bu-mapping-step">
              {/* Mapping content remains same */}
              <div className="mapping-layout">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div className="bu-file-info-section">
                    <div>
                      <img className="bu-csv-icon" src={csvicon} alt="" />
                    </div>
                    <div>
                      <div className="bu-file-name-large">{uploadedFile?.name || 'samplefile.csv'}</div>
                      <span className="bu-file-size-large">{uploadedFile?.size}</span>
                    </div>
                  </div>
                  <div>
                    <div className="bu-file-meta-info">
                      <span className="bu-file-entities">{getFileEntitiesCount()} Entries Found</span>
                    </div>
                  </div>
                </div>

                {showAlreadyMapped && (
                  <div className="bu-status-info">
                    <div className="bu-info-message">
                      <span className="bu-info-icon">ℹ️</span>
                      Some entries are already mapped. Remove them to proceed with valid entries.
                    </div>
                    <button
                      className="bu-btn-remove-all"
                      onClick={onRemoveAllAlreadyMapped}
                      disabled={!validationResults?.unmappedValidCount && validationResults?.alreadyMappedCount === 0}
                    >
                      Remove All Already Mapped
                    </button>
                  </div>
                )}

                <div className="bu-mapping-columns-container">
                  <div className="bu-mapping-column-wrapper">
                    <div className="bu-entries-column bu-scrollable-column">
                      {mappingData.map((entry, index) => (
                        <div key={entry.id} className="bu-mapping-entry-container">
                          <div className="bu-mapping-entry">
                            <span className="bu-entry-prefix">{index + 1}</span>
                            <span className="bu-entry-value">{entry.uid}</span>
                          </div>
                          {entry.isAlreadyMapped && (
                            <button
                              className="bu-remove-entry-btn"
                              onClick={() => onRemoveEntry(entry.id)}
                              title="Remove this entry"
                            >
                              ×
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bu-mapping-column-wrapper">
                    <div className="bu-entries-column bu-scrollable-column">
                      {mappingData.map((entry, index) => (
                        <div key={entry.id} className="bu-mapping-entry-container">
                          <div className="bu-mapping-entry">
                            <span className="bu-entry-prefix">{index + 1}</span>
                            <span className="bu-entry-value">VMID: {entry.vmId}</span>
                          </div>
                          {entry.isAlreadyMapped && (
                            <div className="bu-already-mapped-badge">
                              Already Mapped
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {!showAlreadyMapped && mappingData.length > 0 && (
                  <div className="bu-map-action-section">
                    <button className="bu-btn-map-large" onClick={onMap} disabled={isMapping}>
                      {isMapping ? 'Mapping...' : `Map ${mappingData.length} Entries`}
                    </button>
                  </div>
                )}

                {hasNoUnmappedEntries && (
                  <div className="bu-no-entries-section">
                    <div className="bu-no-entries-message">
                      No valid entries available for mapping.
                    </div>
                    <button className="bu-btn-try-again" onClick={onTryAgain}>
                      Try Again
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Validation Success Dialog */}
        {showValidationDialog && (
          <div className="bu-dialog-overlay">
            <div className="bu-dialog-container">
              <div className="bu-dialog-header">
                <img src={validationsuccess} alt="" />
                <h3>Validation Successful</h3>
              </div>
              <div className="bu-dialog-actions">
                <button className="bu-btn-dialog-ok" onClick={onValidationDialogOk}>
                  Ok
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Missing Records Dialog */}
        {showMissingRecordsDialog && (
          <div className="bu-dialog-overlay">
            <div className="bu-dialog-container bu-missing-records-dialog">
              <div className="bu-dialog-header">
                <img src={validationfailed} alt="Validation Failed" className="bu-missing-dialog-icon" />
                <h3>Validation Failed</h3>
              </div>
              <div className="bu-missing-records-content">
                {validationResults?.missingRecords && validationResults.missingRecords.length > 0 ? (
                  <div className="bu-missing-records-list">
                    {validationResults.missingRecords.map((record, index) => (
                      <div key={index} className="bu-missing-record-item">
                        Invalid data
                        <div className="bu-missing-record-pair">
                          {record.uids && record.uids.length > 0 && (
                            <div className="bu-missing-record-field">
                              <strong>UIDs ({record.uids.length})</strong>
                              <div className="bu-missing-record-values">
                                {record.uids.join(', ')}
                              </div>
                            </div>
                          )}
                          {record.vmIds && record.vmIds.length > 0 && (
                            <div className="bu-missing-record-field">
                              <strong>VMIDs ({record.vmIds.length})</strong>
                              <div className="bu-missing-record-values">
                                {record.vmIds.join(', ')}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="bu-missing-records-empty">
                    <p>No missing records to display.</p>
                  </div>
                )}
              </div>
              <div className="bu-missing-records-actions">
                <button className="bu-btn-dialog-try-again" onClick={onTryAgain}>
                  Try Again
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Mapping Success Dialog */}
        {showMappingSuccessDialog && (
          <div className="bu-dialog-overlay">
            <div className="bu-dialog-container">
              <div className="bu-dialog-header bu-dialog-header-success">
                <h3>Mapping Successful</h3>
              </div>
              <div className="bu-dialog-content">
                <div className="bu-success-message">
                  <p>Successfully processed {mappingData.length} UID-VM mappings!</p>
                  <p>All entries have been mapped successfully.</p>
                </div>
              </div>
              <div className="bu-dialog-actions">
                <button className="bu-btn-dialog-ok" onClick={onMappingSuccessDialogOk}>
                  Ok
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkUpload;